/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/featureToggle"/>
import { log } from "../lib/logger";
import { getTenantId } from "../lib/path";

const featureToggles: { [index: string]: boolean } = {};

export const isInvoiceImageMailSentFromEndUserFlagName = "IsInvoiceImageMailSentFromEndUser";
export const isOrderRevisionEnabledFlagName = "OX.R124.OrderRevision.EnabledFor";
export const IsCodingSuggestionsV2Enabled = "AC.R111.TenantsWithCodingSuggestionsV2Enabled";
export const IsDocumentFormatMappingEnabled = "BB.R87.EdiDocumentImport.DocumentFormatMapping";
export const HomePageEnabled = "AC.R101.HomePageEnabled";
export const TimeSpentMetricEnabled = "BB.R98.TimeSpentMetric";
export const IsActionableEmailsToggleVisible = "GB.R94.IsActionableEmailsToggleVisible";
export const IsNewApprovalRulesConfigurationEnabled = "PAY.R111.IsNewApprovalRulesConfigurationEnabled";
export const IsNewUserAdministrationSuperTabsEnable = "SSG.R115.EnableUserAdministrationSuperTabs";
export const IsTruncateTrailingZeroesInBudgetAndPv2Enabled = "AX.R121.TruncateTrailingZeroesInBudgetAndPv2.EnabledFor";
export const IsCopyRequisitionEnabled = "AX.R122.CopyRequisition.GA.EnabledFor";
export const IsVersioningMonitoringEnabled = "SSG.R122.IsVersioningMonitoringEnabled";
export const IsServicesTabInRoleAdminPageEnabled = "FC.R128.ServicesTabInRoleAdminPage.EnabledFor";
export const IsInboxFilterAutocompleteEnabled = "SSG.R131-2.InboxFilterAutocomplete.Enabled";
export const IsCopilotPredictedNextApproversEnabled = "SSG.R132-1.CopilotPredictedNextApproversEnabled";
export const IsInvoicingPlanApprovalEnabled = "HOLMES.R129.TenantsWithInvoicingPlanApprovalEnabled";
export const IsAddressManagementEnabled = "OX.R131.AddressManagement.EnabledFor";
export const IsCopilotNotificationWindowEnabled = "SSG.R134-1.CopilotNotificationWindowEnabled";
export const IsUIErrorMessagesLoggingToAppInsightsEnabled = "SSG.R134-2.IsUIErrorMessagesLoggingToAppInsightsEnabled";
export const IsAddressManagementExportImportEnabled = "OX.R135-1.AddressManagementExportImport.EnabledFor";
export const IsFetchApproverThroughRestApiEnabled = "SSG.R136-1.FetchApproverThroughRestApiEnabled";
export const IsCopilotFollowupQuestionsEnabled = "SSG.R136-1.CopilotFollowupQuestionsEnabled";
export const AreCopilotCommentsButtonsEnabled = "SSG.R136-2.CopilotCommentsButtonsEnabled";
export const IsSupplierConversationsConfigurationPageEnabled = "AE.R138.SupplierConversations.IsConfigurationPageEnabled";
export const IsDocumentApprovalRemediumFlowEnabled = "OX.R138.2.DocumentApprovalRemediumFlow.EnabledFor";
export const IsContractBasedInvoiceRemediumFlowEnabled = "SSG.R146.1.IsContractBasedInvoiceRemediumFlow.EnabledFor";
export const IsSupplierInvoicesInboxEnabled = "MM.R139.1.SupplierInvoicesInbox.EnabledFor";
export const IsApaDomainAuthenticationEnabled = "OX.R140.1.ApaDomainAuthenticationEnabled";
export const IsDisplayProcurementImagesFromNewCatalogEnabled = "OX.R142.1.DisplayProcurementImagesFromNewCatalog.EnabledFor";
export const IsCatalogManagementEnabled = "OX.R132-2.CatalogManagement.EnabledFor";
export const IsPurchaseOrderDocumentRemediumFlowEnabled = "OX.R143.2.PurchaseOrderDocumentRemediumFlow.EnabledFor";
export const IsHideControlCenterButtonEnabled = "SSG.R143.1.HideControlCenterButton";
export const IsRejectionManagementEnabled = "SSG.R143.2.IsRejectionManagementEnabled";
export const IsSupplierConversationsAdminPagePostMvpFeaturesEnabled = "AE.R139.SupplierConversations.IsAdminPagePostMVPFeaturesEnabled";
export const IsPurchaseOrderDocumentDescriptionForFTFEnabled = "OX.R144.1.PurchaseOrderDocumentDescriptionForFTF.EnabledFor";
export const IsRemediumCatalogEndpointEnabled = "OX.R144.1.IsRemediumCatalogEndpointEnabled";
export const IsEmailStatusTabEnabled = "LLM.R144.1.EmailStatusTab.EnabledFor";
export const IsCategoryManagementEnabled = "OX.R145.2.CategoryManagement.EnabledFor";
export const IsEmailSendingInRejectionManagementEnabled = "SSG.R146.2.RejectionManagement.EmailSending.EnabledFor";
export const IsScheduledJobConfigurationRepeatTimeEditingDisabled = "SM.R147.1.ScheduledJobConfiguration.RepeatTimeEditingDisabled";
export const IsUseMatchingPerOrderTypeEnabled = "GB.R143.2.UseMatchingPerOrderType";
export const IsCompanyTreeAutoCompleteInContractCategoryEnabled = "FH.R147.2.CompanyTreeAutoCompleteInContractCategory.EnabledFor";
export const IsRejectionManagementDocumentImportViewForReportsEnabled = "SSG.R148.1.RejectionManagement.DocumentImportViewForReports.EnabledFor";
export const IsRejectionManagementModalInVerifyStepEnabled = "SSG.R148.1.RejectionManagement.ModalInVerifyStep.EnabledFor";
export const IsTabCountsEnabled = "MM.R149.2.Inbox.TabCounts.EnabledFor";
export const IsRedirectToBifrostEnabled = "MM.R149.1.RedirectToBifrost.EnabledFor";
export const IsBulkAndCopyCodingEnabled = "OX.R150.1.BulkAndCopyCoding.EnabledFor";
export const IsBulkApproveOnBehalfEnabled = "MM.R151.1.BulkApproveOnBehalf.EnabledFor";
export const IsPunchOutDistributedCacheStorageEnabled = "OX.R151.2.PunchOutDistributedCacheStorage.EnabledFor";

export function register(name: string, value: boolean) {
    featureToggles[name] = value;
    log(`Feature toggle '${name}' set to '${value}'.`);
}

export function registerMany(toggles: { [key: string]: boolean }) {
    for (const [key, value] of Object.entries(toggles)) {
        register(key, value);
    }
}

export function getFlagValue(name: string) {
    return featureToggles[name];
}

export function isOrderRevisionEnabled() {
    return getFlagValue(isOrderRevisionEnabledFlagName);
}

export function isCodingSuggestionsV2Enabled() {
    return getFlagValue(IsCodingSuggestionsV2Enabled);
}

export function isDocumentFormatMappingEnabled() {
    return getFlagValue(IsDocumentFormatMappingEnabled);
}

export function isTimeSpentMetricEnabled() {
    return getFlagValue(TimeSpentMetricEnabled);
}

export function isLocalEnvironment() {
    return window.location.hostname === "localhost";
}

export function isDevDeployment() {
  const hostname = window.location.hostname;
  // matches dev{some number}.cloud.mediusflow.com
  const devPattern = /^dev\d+\.(cloud\.)?mediusflow\.com$/;
  return devPattern.test(hostname);
}

export function isHomePageEnabled() {
    const flag = getFlagValue(HomePageEnabled);

    // check on local environemnt
    if (flag && isLocalEnvironment())
        return true;
    // check on dev deployments
    if (flag && isDevDeployment())
        return true;
    // check on prod deployments
    if (flag && getTenantId().toLowerCase() !== "maintenantmanager")
        return true;
    
    return false;
}

export function isActionableEmailsToggleVisible() {
    return getFlagValue(IsActionableEmailsToggleVisible);
}

export function isNewApprovalRulesConfigurationEnabled() {
    return getFlagValue(IsNewApprovalRulesConfigurationEnabled);
}

export function isNewUserAdministrationSuperTabsEnabled() {
    return getFlagValue(IsNewUserAdministrationSuperTabsEnable);
}

export function isTruncateTrailingZeroesInBudgetAndPv2Enabled() {
    return getFlagValue(IsTruncateTrailingZeroesInBudgetAndPv2Enabled);
}

export function isCopyRequisitionEnabled() {
    return getFlagValue(IsCopyRequisitionEnabled);
}

export function isVersioningMonitoringEnabled() {
    return getFlagValue(IsVersioningMonitoringEnabled);
}

export function isServicesTabInRoleAdminPageEnabled() {
    return getFlagValue(IsServicesTabInRoleAdminPageEnabled);
}

export function isCopilotPredictedNextApproversEnabled() {
    return getFlagValue(IsCopilotPredictedNextApproversEnabled);
}

export function isInboxFilterAutocompleteEnabled() {
    return getFlagValue(IsInboxFilterAutocompleteEnabled);
}

export function isInvoicingPlanApprovalEnabled() {
    return getFlagValue(IsInvoicingPlanApprovalEnabled);
}

export function isAddressManagementEnabled() {
    return getFlagValue(IsAddressManagementEnabled);
}

export function isCopilotNotificationWindowEnabled() {
    return getFlagValue(IsCopilotNotificationWindowEnabled);
}

export function areCopilotCommentsButtonsEnabled() {
    return getFlagValue(AreCopilotCommentsButtonsEnabled);
}

export function isUIErrorMessagesLoggingToAppInsightsEnabled() {
    return getFlagValue(IsUIErrorMessagesLoggingToAppInsightsEnabled);
}

export function isAddressManagementExportImportEnabled() {
    return getFlagValue(IsAddressManagementExportImportEnabled);
}

export function isFetchApproverThroughRestApiEnabled() {
    return getFlagValue(IsFetchApproverThroughRestApiEnabled);
}

export function isCopilotFollowupQuestionsEnabled() {
    return getFlagValue(IsCopilotFollowupQuestionsEnabled);
}

export function isSupplierConversationsConfigurationPageEnabled() {
    return getFlagValue(IsSupplierConversationsConfigurationPageEnabled);
}

export function isDocumentApprovalRemediumFlowEnabled() {
    return getFlagValue(IsDocumentApprovalRemediumFlowEnabled);
}

export function isContractBasedInvoiceRemediumFlowEnabled() {
    return getFlagValue(IsContractBasedInvoiceRemediumFlowEnabled);
}

export function isSupplierInvoicesInboxEnabled() {
    return getFlagValue(IsSupplierInvoicesInboxEnabled);
}

export function isApaDomainAuthenticationEnabled() {
    return getFlagValue(IsApaDomainAuthenticationEnabled);
}

export function isRemediumCatalogEndpointEnabled() {
    return getFlagValue(IsRemediumCatalogEndpointEnabled);
}

export function isDisplayProcurementImagesFromNewCatalogEnabled() {
    return getFlagValue(IsDisplayProcurementImagesFromNewCatalogEnabled);
}

export function isCatalogManagementEnabled() {
    return getFlagValue(IsCatalogManagementEnabled);
}

export function isPurchaseOrderDocumentRemediumFlowEnabled() {
    return getFlagValue(IsPurchaseOrderDocumentRemediumFlowEnabled);
}

export function isControlCenterButtonEnabled() {
    return !getFlagValue(IsHideControlCenterButtonEnabled);
}

export function isSupplierConversationsAdminPagePostMvpFeaturesEnabled() {
    return getFlagValue(IsSupplierConversationsAdminPagePostMvpFeaturesEnabled);
}

export function isPurchaseOrderDocumentDescriptionForFTFEnabled() {
    return getFlagValue(IsPurchaseOrderDocumentDescriptionForFTFEnabled);
}
    
export function isRejectionManagementEnabled() {
    return getFlagValue(IsRejectionManagementEnabled);
}

export function isRejectionManagementModalInVerifyStepEnabled() {
    return getFlagValue(IsRejectionManagementModalInVerifyStepEnabled);
}

export function isEmailStatusTabEnabled() {
    return getFlagValue(IsEmailStatusTabEnabled);
}

export function isCategoryManagementEnabled() {
    return getFlagValue(IsCategoryManagementEnabled);
}

export function isEmailSendingInRejectionManagementEnabled() {
    return getFlagValue(IsEmailSendingInRejectionManagementEnabled);
}

export function isScheduledJobConfigurationRepeatTimeEditingDisabled() {
    return getFlagValue(IsScheduledJobConfigurationRepeatTimeEditingDisabled);
}

export function isUseMatchingPerOrderTypeEnabled() {
    return getFlagValue(IsUseMatchingPerOrderTypeEnabled);
}

export function isCompanyTreeAutoCompleteInContractCategoryEnabled() {
    return getFlagValue(IsCompanyTreeAutoCompleteInContractCategoryEnabled);
}

export function isRejectionManagementDocumentImportViewForReportsEnabled() {
    return getFlagValue(IsRejectionManagementDocumentImportViewForReportsEnabled);
}

export function isTabCountsEnabled() {
    return getFlagValue(IsTabCountsEnabled);
}

export function isRedirectToBifrostEnabled() {
    return getFlagValue(IsRedirectToBifrostEnabled);
}

export function isBulkAndCopyCodingEnabled() {
    return getFlagValue(IsBulkAndCopyCodingEnabled);
}

export function isBulkApproveOnBehalfEnabled() {
    return getFlagValue(IsBulkApproveOnBehalfEnabled);
}

export function isPunchOutDistributedCacheStorageEnabled() {
    return getFlagValue(IsPunchOutDistributedCacheStorageEnabled);
}